import ReportUtils from "../../../../../../utils/report-utils.js";
import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";

export default function ConductHistory({ data }) {
    const conduct = data?.conductHistory ?? {};
    const [gridApi, setGridApi] = useState(null);

    const columnDefs = useMemo(() => ([
        { headerName: "Data", field: "date", sort: "desc", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
        { headerName: "Ação", field: "action", flex: 1},
        { headerName: "Observação", field: "observation", flex: 1 }
    ]), [conduct])

    return (
        <div className="space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] mb-2">
                Histórico de conduta
            </h2>

            <div className="w-full print:hidden mb-6">
                <AgGridReact
                    rowData={conduct ?? {}}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={aggridUtils.generalTheme()}
                    onGridReady={(params) => setGridApi(params.api)}
                    domLayout="autoHeight"
                />
            </div>

            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3] mb-6">
                <PrintableTableAgGrid
                    formatters={{date: (row) => ReportUtils.formatDateOnly(row.date)}}
                    gridApi={gridApi}
                    className="border-0! w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}